<template>
  <div class="grid-column-start-2_md grid-column-end-4_md flex flex-column justify-items-center vh75">
    <header class="mb2 mt-margin">
      <h1 class="font-size-8">Who&rsquo;s on your&nbsp;team?</h1>
      <h2>Add the names and job titles of the people on your team.</h2>
      <p class="font-size-4">You&rsquo;ll be using them to help shape your estimates. You can edit these later.</p>
      <p class="font-size-4">You need to add at least one team member.</p>
    </header>
    <section class="team-list mb2">
      <div
        v-for="(person, key) in team"
        :key="key">
        <p class="display font-size-4 grey-text"><span class="display bold font-size-5 accent-text">{{ person.fullName }}&nbsp;</span> {{ person.title }}</p>
      </div>
    </section>
    <form
      class="flex_sm flex-end justify-content-space-between align-items-flex-end mb2"
      @submit.prevent="addPerson">
      <lw-text-input
        v-validate.disable="'required'"
        ref="fullName"
        :placeholder="'e.g. Wanda Johnson'"
        :id="'fullName'"
        :label="'Name'"
        :name="'fullName'"
        :size="'large c1'"
        v-model="fullName"
        :error="errors.first('fullName')"
      />
      <lw-text-input
        :id="'title'"
        :placeholder="'e.g. Designer'"
        :label="'Title'"
        :name="'title'"
        :size="'large c1'"
        v-model="title"/>
      <div class="mb1"><button
        type="submit"
        name="submit"
        class="large-button full-button_mb">Add&nbsp;person</button></div>
    </form>
    <div class="flex justify-content-space-between align-items-center align-baseline mb-margin">
      <button
        class="invisible-button negative-button"
        @click.prevent="$router.go(-1)"><svg-left/>Back</button>
      <button
        :class="team.length < 1 ? 'disabled disabled-button' : 'accent-button'"
        :disabled="team.length < 1"
        type="submit"
        class="large-button"
        @click.prevent="$router.push({ name: 'getStarted' })">Next</button>
    </div>
  </div>
</template>

<script>
import * as firebase from 'firebase'
import sync from '../../mixins/sync'
import { mapGetters } from 'vuex'
import TextInput from '../../livewires/TextInput.vue'
import Left from '../../svgs/Left.vue'

export default {
  components: {
    lwTextInput: TextInput,
    svgLeft: Left
  },
  mixins: [ sync ],
  data () {
    return {
      fullName: '',
      title: ''
    }
  },
  computed: {
    ...mapGetters([
      'user',
      'team',
      'organization'
    ])
  },
  mounted () {
    this.$refs.fullName.$el.children[0].focus()
  },
  methods: {
    addPerson () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$store.dispatch('saveState', false)
          const name = this.fullName.split(' ')
          let first = name.slice(0, -1).join(' ')
          let last = name.slice(-1).join(' ')
          if (first === '') {
            first = last
            last = ''
          }
          const updated = firebase.default.firestore.FieldValue.serverTimestamp()
          const payload = {
            fullName: this.fullName,
            firstName: first,
            lastName: last,
            title: this.title,
            organization: this.user.selectedOrganization,
            owner: this.user.id,
            created: updated,
            updated: updated,
            archived: false
          }
          this.$store.dispatch('addPerson', payload)
          this.fullName = ''
          this.title = ''
          this.$refs.fullName.$el.children[0].focus()
        }
      })
    }
  }
}
</script>

<style scoped>
  .mb2 {
    margin-bottom: var(--line);
  }
</style>
